export const TRUE = 'true';
export const FALSE = 'false';
export const DISPUTED = 'disputed';
export const ASSUMED = 'assumed';
export const DEFAULT = ASSUMED;